export const ProductActionTypes = {
    FETCH_PRODUCT: '@@product/FETCH_PRODUCT',
    SET_PRODUCT: '@@product/SET_PRODUCT',
    TOGGLE_SIZEGUIDE: '@@product/TOGGLE_SIZEGUIDE',
};
export const UserInfoActionTypes = {
    /** @deprecated - don't use redux for this, just call api.getUserInfo() */
    FETCH_USERINFO: '@@userInfo/FETCH_USERINFO',
};
export const SearchActionTypes = {
    TOGGLE_SEARCH: '@@search/TOGGLE_SEARCH',
    INPUT_SEARCH: '@@search/INPUT_SEARCH',
    FETCH_SEARCH: '@@search/FETCH_SEARCH',
    FETCH_SEARCH_REFINEMENT: '@@search/FETCH_SEARCH_REFINEMENT',
    FETCH_LISTING: '@@search/FETCH_LISTING',
    FETCH_LISTING_REFINEMENT: '@@search/FETCH_LISTING_REFINEMENT',
    TOGGLE_LANDING_ANIMATION: '@@search/TOGGLE_LANDING_ANIMATION',
};
export const MinicartActionTypes = {
    FETCH_MINICART_AFTER_UPDATE: '@@search/FETCH_MINICART_AFTER_UPDATE',
    FETCH_MINICART_AND_OPEN: '@@search/FETCH_MINICART_AND_OPEN',
    FETCH_MINICART: '@@search/FETCH_MINICART',
    UPDATE_MINICART: '@@search/UPDATE_MINICART',
    CLOSE_MINICART: '@@search/CLOSE_MINICART',
};
export const BagActionTypes = {
    FETCH_BAG: '@@bag/FETCH_BAG',
    UPDATE_PRODUCT_SIZE: '@@bag/UPDATE_PRODUCT_SIZE',
    REMOVE_PRODUCT_FROM_BAG: '@@bag/REMOVE_PRODUCT_FROM_BAG',
    INCREASE_QUANTITY: '@@bag/INCREASE_QUANTITY',
    DECREASE_QUANTITY: '@@bag/DECREASE_QUANTITY',
    ADD_PROMO_CODE: '@@bag/ADD_PROMO_CODE',
    PROMOCODE_REMOVE: '@@bag/PROMOCODE_REMOVE',
};
export const AccountActionTypes = {
    FETCH_PROFILE: '@@account/FETCH_PROFILE',
    UPDATE_PROFILE: '@@account/UPDATE_PROFILE',
    FETCH_ADDRESSES: '@@account/FETCH_ADDRESSES',
    FETCH_MODEL: '@@account/FETCH_MODEL',
    DELETE_ADDRESSES: '@@account/DELETE_ADDRESSES',
    FETCH_SAVEDCARDS: '@@account/FETCH_SAVEDCARDS',
    DELETE_SAVEDCARD: '@@account/DELETE_SAVEDCARD',
};
export const OrdersActionTypes = {
    FETCH_ORDERS: '@@orders/FETCH_ORDERS',
    FETCH_ORDERS_DETAIL: '@@orders/FETCH_ORDER_DETAIL',
    FETCH_RETURNS: '@@orders/FETCH_RETURNS',
    FETCH_RETURNREASONS: '@@orders/FETCH_RETURNREASONS',
    OPEN_RETURN: '@@orders/OPEN_RETURN',
    CLEAN_FORM_ERRORS: '@@orders/CLEAN_FORM_ERRORS',
    CLOSE_RETURN: '@@orders/CLOSE_RETURN',
    UPDATE_RETURN: '@@orders/UPDATE_RETURN',
    SUBMIT_RETURN: '@@orders/SUBMIT_RETURN',
    SUBMIT_EXCHANGE: '@@orders/SUBMIT_EXCHANGE',
};
export const AftercareActionTypes = {
    FETCH_AFTERCARE: '@@orders/FETCH_AFTERCARE',
    UPDATE_AFTERCARE: '@@orders/UPDATE_AFTERCARE',
};
export const CheckoutActionTypes = {
    FETCH_CHECKOUTDATA: '@@checkout/FETCH_CHECKOUTDATA',
    UPDATE_ORDER: '@@checkout/UPDATE_ORDER',
    UPDATE_EMAIL: '@@checkout/UPDATE_EMAIL',
    UPDATE_PAYMENTERROR: '@@checkout/UPDATE_PAYMENTERROR',
    UPDATE_SHIPPINGMETHODS: '@@checkout/UPDATE_SHIPPINGMETHODS',
    UPDATE_CUSTOMER: '@@checkout/UPDATE_CUSTOMER',
    UPDATE_NONCE: '@@checkout/UPDATE_NONCE',
    UPDATE_PAYMENTMETHOD: '@@checkout/UPDATE_PAYMENTMETHOD',
    UPDATE_ACTIVATIONADDRESS: '@@checkout/UPDATE_ACTIVATIONADDRESS',
    FETCH_ADDRESSES: '@@checkout/FETCH_ADDRESSES',
    FETCH_PAYMENTMETHODS: '@@checkout/FETCH_PAYMENTMETHODS',
    FETCH_PICKUP: '@@checkout/FETCH_PICKUP',
};
export const ConnectivityActionTypes = {
    FETCH_CONNECTIVITYDATA: '@@connectivity/FETCH_CONNECTIVITYDATA',
    UPDATE_REGISTRY: '@@connectivity/UPDATE_REGISTRY',
    UPDATE_PAYMENTMETHOD: '@@connectivity/UPDATE_PAYMENTMETHOD',
    UPDATE_PAYMENTDATA: '@@connectivity/UPDATE_PAYMENTDATA'
};
export const AccordionStepsActionTypes = {
    NAVIGATE_STEP: '@@accordion/NAVIGATE_STEP',
};
export const StoreLocatorActionTypes = {
    FETCH_STORES: '@@storelocator/FETCH_STORES',
    FETCH_STORE_DETAILS: '@@storelocator/FETCH_STORE_DETAILS',
    UPDATE_BOUNDS: '@@storelocator/UPDATE_BOUNDS',
    USE_LOCATION: '@@storelocator/USE_LOCATION',
};
